module.exports = __webpack_public_path__ + "media/images/lb/949-08fc411206b5a9ad25ba750b197e6f5e.svg";